const zhTW = {
  button: {
    search: '搜尋',
    total: `共`,
    items: `條`,
    submit: '送出',
    EDIT: '編輯',
    confirm_delete: '確認刪除',
    LOGOUT: '登出',
    OK: '確定',
    CANCEL: '取消',
    DELETE: '刪除',
    RENT: '租借',
    RETURN: '歸還',
    NEW: '新增',
    EXPORT: '匯出',
    OPERATE: '操作',
    SETTING: '設定',
    IMPORT: '匯入',
    RANGE: '區間',
    CONFIRM_RESET_PASSWORD: '確認重置密碼',
    all: '全部',
    CONFIRM_CANCEL: '確定取消',
    UPDATE: '更新',
    BATCH: '批量',
    DOWNLOAD: '下載',
    ARCHIVED: '封存',
  },
  error: {
    PLEASE_ENTER: (fieldName: string) => `請輸入${fieldName}`,
    failed: '失敗',
    success: '成功',
    unauthorized: "系統已登出",
    IMAGE_TOO_LARGE: '圖片不得大於5MB',
    SUCCESS_EXPORT: "下載成功",
    MORE_THAN_MAX_FILE: "此教師已達五個檔案上限",
    NO_PERMISSION: "沒有權限",
    REJECT_SELECTED_THE_SAME_SUBJECT: "不可選擇重複的科目",
  },
  menuTitle: {
    classAnnounce: '教室公告',
    studentList: '學生資料',
    lostAndFound: '失物招領',
    accountInfo: '帳戶資訊',
    rent: '物品租借',
    rollCall: '自習名單',
    attendance: '出勤系統',
    buyRecord: '購買紀錄',
    sale: '售貨系統',
    leaveSystem: '請假系統',
    rentPlace: '場地租借',
    bus: '校車系統',
    schedule: '行事曆',
    organization: '組織管理',
    classManagement: '班級管理',
    permissionManagement: '部門權限管理',
    humanResourceManagement: '人事管理',
    studentManagement: '學生管理',
    teacherManagement: '教師管理',
    semesterManagement: '學期管理',
    subjectManagement: '科目管理',
    transcript: '成績單管理',
    archived: '封存紀錄',
    archivedTranscript: '成績單',
  },
  buyRecord: {
    NAME: '姓名',
    ID: '帳號',
    TIME: '時間',
    SUBJECT: '科目',
    BUY_ITEM: '購買物品',
    UNIT_PRICE: '單價',
    QUANTITY: '數量',
    TOTAL: '總額',
    BALANCE: '餘額',
    DATE: '日期',
    EXCEL_NAME: {
      MENU_TITLE: '購買紀錄',
    },
    EXPORT_BY_NORMAL: '一般匯出',
    EXPORT_BY_PEOPLE: '以人匯出',
    EXPORT_BY_CATEGORY_SUBJECT: '以分類科目匯出',
    EXPORT_ALL_USER_BALANCE: '匯出所有帳號餘額',
    DEPARTMENT: '部門',
    CLASS: '班級',
    ACCESS_CARD_NUMBER: '門禁卡號',
  },
  announcement: {
    TEACHER: '老師',
    CLASSROOM: '教室',
    SITE_NO: '座號',
    CN_NAME: '中文姓名',
    EN_NAME: '英文姓名',
    SIGN_SITUATION: '出勤狀況',
    ALLERGY: '過敏',
    LUNCH: '午餐',
    SNACK: '點心',
    AFTER_SCHOOL: '放學後',
    CLASS: '班級',
    SHOULD_ARRIVE: '應到',
    ACTUALLY_ARRIVE: '實到',
    NOT_ARRIVE: '未到',
  },
  rollCall: {
    CLASS: '班級',
    CLASSROOM: '教室',
    NAME: '學生姓名',
    TIME: '時間',
    LAST_WEEK: '上週',
    THIS_WEEK: '本週',
    NEXT_WEEK: '下週',
  },
  lostAndFound: {
    DATE: '日期',
    ITEM: '物品',
    PICTURE: '圖片',
    PLACE: '地點',
    OPERATE: '操作',
  },
  layOutPage: {
    FOOTER_TEXT: '亞伯拉罕英語學院© Copyright All Rights Reserved.',
  },
  studentList: {
    TEACHER: '老師',
    CLASSROOM: '教室',
    SEAT_NO: '座號',
    ACCOUNT: '帳號',
    CN_NAME: '中文姓名',
    EN_NAME: '英文姓名',
    MORE_INFO: '更多資訊',
    DETAIL_INFO: '個人資訊',
    CLASS: '班級',
    CLASS_NAME: '名稱',
    NEW_CLASS: '新增班級',
    OPERATE: '操作',
    CLASS_SEARCH: '班級分類',
    PERSON_SEARCH: '個人搜尋',
    INTERVAL: '課程別',
    REGISTER: '學生註冊',
    CHANGE_CLASSROOM: '轉班',
    NAME: '姓名',
    SIGN: '點名',
    TIME: '時間',
    SELFSTUDY: '自習資訊',
    CHANGE_PASSWORD: '修改密碼',
    RESET_PASSWORD: '重置密碼',
    TEMP_PASSWORD: '臨時密碼',
    FULL_DAY: 'Full Day',
    PM: 'PM',
    EVE: 'EVE',
    LEAVED: 'LEAVE',
    AVERAGE_SCORE: '平均分數',
  },
  bus: {
    CN_NAME: '中文姓名',
    EN_NAME: '英文姓名',
    CN_SCHOOL: '中文小學',
    CLASS_SITE_NO: '班級座號',
    SITUATION: '狀況',
    SIGN: '點名',
    CONTACT: '聯絡人',
    TAKE_RIDE: '搭乘',
    NOT_TAKE_RIDE: '不搭乘',
    SCHOOL: '學校',
    NEW_BUS_TIME: '新增時段',
    TIME: '時段',
    TIME_SHOW: '顯示時段',
    TIME_REAL: '實際時段',
    NEW_SCHOOL: '新增學校',
    NEW_STUDENT: '新增學生',
    GRADE: '年',
    CLASSROOM: '班',
    SEAT_NUMBER: '號',
    EDIT_TAKE_BUS_LIST: '編輯搭乘清單',
    TAKE_BUS_LIST: '搭乘清單',
    PATH: '路線',
    DAY_OF_WEEK: '星期',
  },
  sale: {
    ITEM: '品項',
    UNIT_PRICE: '單價',
    DISCOUNT: '折扣(元)',
    QUANTITY: '數量',
    AMOUNT: '金額',
    CATEGORY: '分類',
    SUBJECT: '科目',
    NEW_CATEGORY: '新增分類',
    NEW_SUBJECT: '新增科目',
    CATRGORY_NAME: '名稱',
    NEW_PRODUCT: '新增商品',
    PRODUCT: '商品',
    CHECKOUT: '結帳',
    OPERATE: '操作',
    SELL_PRODUCT: '販售商品',
    ACCOUNT: '帳號',
    BALANCE: '帳戶餘額',
    TOTAL: '購買總額',
    PURCHASER: '購買人',
    BALANCE_NOT_ENOUGH: '餘額不足',
    STUDENT_ID_PLACEHOLDER: '個人條碼或輸入帳號',
    ACCESS_CARD_NUMBER: '門禁卡號',
    CHECKOUT_BY: '結帳依據',
  },
  login: {
    USERNAME: '帳號',
    PASSWORD: '密碼',
    LOGIN: '登入',
    FORGET_PASSWORD: '忘記密碼',
    LOGIN_FAIL: '登入失敗',
    LOGIN_TITLE: '登入資訊',
  },
  profileInfo: {
    NAME: '姓名',
    HONE_PHONE: '電話(H)',
    OFFICE_PHONE: '電話(O)',
    CELLPHONE: '行動電話',
    EMAIL: 'E-mail',
    BIRTHDAY: '生日',
    GENDER: '性別',
    RESIDENCE_ADDRESS: '戶籍地址',
    MAILING_ADDRESS: '通訊地址',
    IDENTITY_NUMBER: '身分證字號',
    SCHOOL: '中文小學',
    ALLERGY: '過敏原',
    RELATIONSHIP: '稱謂',
    NAME_CN: '中文姓名',
    NAME_EN: '英文姓名',
    MALE: '男',
    FEMALE: '女',
    MODAL_TITLE_EDIT: '個人資料修改',
    AVATAR: '照片',
    QRCODE: 'QRCode',
    STUDENT_CARD: '證件',
    CHANGE_PASSWORD: '修改密碼',
    OLD_PASSWORD: '舊密碼',
    NEW_PASSWORD: '新密碼',
    CHECK_PASSWORD: '確認密碼',
    PROFILE_INFO: '個人資訊',
    CLASSROOM: '班級',
    SITE_NO: '座號',
    GRADE: '年級',
    SCHOOL_CLASSROOM: '小學班級',
    SCHOOL_SITE_NO: '小學座號',
    PASSWORD: '密碼',
    TEACHER_INFO: '教師資訊',
    IS_LUNCH: '午餐',
    IS_SNACK: '點心',
    ACCOUNT: '帳號',
    DUE_DATE: '到職日',
    TERMINATION_DATE: '離職日',
    CONTACT: '聯絡人',
    AGENT: '代理人',
    DEPARTMENT: '部門',
    ROLE: '職稱',
    EXTENSION: '分機',
    BUSINESS_EMAIL: '公司E-mail',
    PERSONAL_EMAIL: '個人E-mail',
    ACCESS_CARD_NUMBER: '門禁卡號',
    OTHER_DOCUMENT: '其他檔案',
  },
  leave: {
    START: '開始',
    END: '結束',
    SICK: '病假',
    PERSONAL: '事假',
    OTHER: '其他',
    NEW_LEAVE: '新增假單',
    LAST_WEEK: '上一周',
    NEXT_WEEK: '下一周',
    LEAVE_TICKET: '請假單',
    STUDENT: '學生',
    TIME: '時間',
    LEAVE_TYPE: '假別',
    REASON: '事由',
    DELETE_OPTION_1: '此請假日期',
    DELETE_OPTION_2: '此請假日期和後續請假日期',
    DELETE_OPTION_3: '此請假項目所有日期',
    REPEAT_DATE: '重複日期',
    REPEAT_DATE_END: '結束時間',
    REPEAT_INFINTY: '永不結束',
    REPEAT_TO: '於',
  },
  rentOutField: {
    THREE_LOBBY: '3F大廳',
    LIBRARY: '圖書館',
    PERFORMANCE_HALL: '展演廳',
    RENT_PLACE: '場地租借',
    PLACE: '場地',
    TIME: '時間',
    USE_CLASS: '使用班級',
    USE: '用途',
  },
  rent: {
    NEW_CATEGORY: '新增分類',
    CATEGORY: '分類',
    NEW_ITEM: '新增物品',
    ITEM: '物品',
    DESCRIPTION: '描述',
    STATUS: '狀態',
    RENT_PERSON: '租借人',
    RETURN_PERSON: '歸還人',
    RENT_TIME: '出借時間',
    RETURN_TIME: '歸還時間',
    OPERATE: '操作',
    CAN_RENT: '可租借',
    RENTING: '出借中',
    RENT: '租借',
    RETURN: '歸還',
    DATE: '日期',
    STUDENT_ID_PLACEHOLDER: '個人條碼或輸入帳號',
    ACCESS_CARD_NUMBER: '門禁卡號',
    RENT_BY: '租借依據',
  },
  attendance: {
    TIME: '時間',
    NAME_CN: '中文姓名',
    NAME_EN: '英文姓名',
    ACCOUNT: '帳號',
    STUDENT_ID_PLACEHOLDER: '個人條碼或輸入帳號',
    QRCODE: 'QRCode',
    STUDENT_LIST: '學生清單',
    ACCESS_CARD_NUMBER: '門禁卡號',
  },
  selfStudy: {
    NAME: '姓名',
    BEFORE_SCHOOL: '上學前',
    AFTER_SCHOOL: '放學後',
  },
  schedule: {
    ALL: '全部',
    TEACHER: '老師',
    STUDENT: '學生',
    ANNOUNCEMENT: '公告',
    IMPORTANT_ANNOUNCEMENT: '重點公告',
    YES: '是',
    NO: '否',
    ANNOUNCEMENT_TARGET: '公告對象',
    TITLE: '標題',
    CONTENT: '內容',
    ANNOUNCEMENT_PLACE: '公告處室',
    TIME: '時間',
    START: '開始',
    END: '結束',
    IS_VACATION: '補假',
    IS_MAKE_UP_DATE: '補班',
    MAKE_UP_DATE: '補班日期',
    IS_SHOW_HOLIDAY: '顯示休假',
  },
  organization: {
    DEPARTMENT: '部門',
    ROLE: '職稱',
    PERMISSION: '權限',
    STUDENT_RESIGN: '離校',
    STUDENT_WORK: '在校',
    TEACHER_RESIGN: '離職',
    TEACHER_WORK: '在職',
    STUDENT: '學生',
    TEACHER: '老師',
  },
  semester: {
    YEAR: '學年',
    SEMESTER: '學期',
    EXAM: '考試',
    CLASS: '班級',
  },
  subject: {
    SUBJECT: '科目',
    EN_NAME: '英文名稱',
    CN_NAME: '中文名稱',
    SUBJECT_DESCRIPTION: '科目說明',
    NEW_SUBJECT: '新增科目',
    PDF_TEMPLATE: '匯出PDF模板',
    TEMPLATE_1: 'GLevel',
    TEMPLATE_2: 'ESL',
    SI: 'Scholastic I',
    SII: 'Scholastic II',
    SIII: 'Scholastic III',
    OP: 'Overall Performance',
    S: 'Scholastic',
    C: 'Conduct',
    LA: 'Language Arts',
  },
  home: {
    DOCUMENT_SHARE: '檔案分享',
    DOCUMENT: '檔案',
    MEDIA_SHARE: '影音分享',
    MEDIA: '影音',
    VIDEO: '影片',
    PICTURE: '圖片',
    NONE: '無',
    MEDIA_TYPE: '影音類型',
    VIDEO_URL: '影片網址',
    RECENT_SCHEDULE: '近日公告',
    OFFICE_SCHEDULE: '處室公告',
    STUDENT_SCHEDULE: '學生請假公告',
  },
  transcript: {
    SCORING: '個人評分',
    BATCH_SCORING: '單科評分',
    TRANSCRIPT: '成績單',
  },
  errorCode: {
    USER_EXIST: '學號已存在',
    DUPLICATE_RENT_PLACE: '所選時段已被預約',
    ANNOUNCEMENT_ERROR: '教室重複設定，請重新配置',
  },
};

export default zhTW;